import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardHeader,
    Container,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@material-ui/core";
import Header from "../../components/Headers/Header";
import componentStyles from "../../assets/theme/views/admin/tables.js";
import { BACKEND_URL } from "../../env.js";
import { toast } from "react-toastify";
import axios from "axios";

const useStyles = makeStyles(componentStyles);

function SubAdminInvoice() {
    const [openModel, setOpenModel] = useState(false);
    const [invoice, setInvoice] = useState([]);
    const [loading, setLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState({
        return: "",
        total: "",
        fromDate: "",
        toDate: "",
    });

    const classes = useStyles();
    const GetAllInvoice = () => {

        axios.get(`${BACKEND_URL}/subadminInvoice`, {
            // headers: { token }
        })
            .then(res => setInvoice(res.data))
            .catch(err => {
                console.error(err)
                setInvoice([])
            });
    }
    useEffect(() => {
        GetAllInvoice()
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setInvoiceData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleCreateInvoice = async () => {
        try {
            setLoading(true);
            const payload = {
                returnCharges: invoiceData.return,
                totalPayout: invoiceData.total,
                fromDate: invoiceData.fromDate,
                toDate: invoiceData.toDate,
            };

            const res = await axios.post(`${BACKEND_URL}/subadminInvoice`, payload);

            console.log("Invoice created:", res.data);

            // Reset form or close modal
            setInvoiceData({
                return: "",
                total: "",
                fromDate: "",
                toDate: "",
            });
            setOpenModel(false);

            // Optional: show success message
            toast.success("Invoice created successfully!");
            GetAllInvoice()
        } catch (error) {
            console.error("Error creating invoice:", error);
            toast.error("Failed to create invoice!");
        } finally {
            setOpenModel(false);
            setLoading(false);
        }
    };


    return (
        <>
            <Header />
            <Container
                maxWidth={false}
                component={Box}
                marginTop="-6rem"
                classes={{ root: classes.containerRoot }}
            >
                <Card
                    style={{ marginTop: "20px" }}
                    classes={{ root: classes.cardRoot }}
                >
                    <CardHeader
                        className={classes.cardHeader}
                        title="Invoice"
                        titleTypographyProps={{
                            component: Box,
                            marginBottom: "0!important",
                            variant: "h3",
                        }}
                        action={
                            <Box display="flex" alignItems="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setOpenModel(!openModel)}
                                >
                                    Create Invoice
                                </Button>
                            </Box>
                        }
                    />
                    {invoice?.length >= 1 ? (
                        <TableContainer>
                            <Box component={Table} alignItems="center" marginBottom="0!important">
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Invoice Number</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >From Date</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >To Date</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Total Payout</TableCell>
                                        <TableCell
                                            classes={{
                                                root: classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }}
                                        >Return Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoice?.map((inv) => {
                                        return (<TableRow key={inv?.id}>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {inv?.id || 0}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {inv?.fromDate || 0}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {inv?.toDate || 0}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {Number(inv.totalPayout)}
                                            </TableCell>
                                            <TableCell classes={{ root: classes.tableCellRoot }}>
                                                {Number(inv.returnCharges)}
                                            </TableCell>
                                        </TableRow>)
                                    })}
                                </TableBody>
                            </Box>
                        </TableContainer>
                    ) : null}
                </Card>
            </Container>

            {openModel && (
                <Box
                    position="fixed"
                    top={0}
                    left={0}
                    width="100%"
                    height="100%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bgcolor="rgba(0,0,0,0.3)"
                    zIndex={9999}
                >
                    <Card style={{ padding: 20, width: 400 }}>
                        <Typography variant="h5" gutterBottom>Create Invoice</Typography>

                        <TextField
                            fullWidth
                            label="Return"
                            name="return"
                            value={invoiceData.return}
                            onChange={handleChange}
                            margin="normal"
                            variant="outlined"
                        />

                        <TextField
                            fullWidth
                            label="Total"
                            name="total"
                            value={invoiceData.total}
                            onChange={handleChange}
                            margin="normal"
                            variant="outlined"
                        />

                        <TextField
                            fullWidth
                            label="From Date"
                            name="fromDate"
                            type="date"
                            value={invoiceData.fromDate}
                            onChange={handleChange}
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <TextField
                            fullWidth
                            label="To Date"
                            name="toDate"
                            type="date"
                            value={invoiceData.toDate}
                            onChange={handleChange}
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <Box mt={2} display="flex" justifyContent="space-between">
                            <Button onClick={handleCreateInvoice} disabled={loading} variant="contained" color="primary">
                                {loading ? "Submitting" : "Submit"}
                            </Button>
                            <Button onClick={() => setOpenModel(false)} variant="outlined">
                                Cancel
                            </Button>
                        </Box>
                    </Card>
                </Box>
            )}
        </>
    );
}

export default SubAdminInvoice;
